import { render, staticRenderFns } from "./ServiceCart.vue?vue&type=template&id=40ce4e74&scoped=true&"
import script from "./ServiceCart.vue?vue&type=script&lang=js&"
export * from "./ServiceCart.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCart.vue?vue&type=style&index=0&id=40ce4e74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce4e74",
  null
  
)

export default component.exports